import bubbleSvg from "../../../public/images/icons/text-bubble.svg";
import PropTypes from "prop-types";

const TextBubble = ({
  text,
  rotation = 0,
  width = 150.25,
  height = 103.36,
  textStyle = {},
  style = {}
}) => {
  const bubbleStyle = {
    width,
    height,
    transform: `rotate(${rotation}deg)`,
    position: "relative",
    flexShrink: 0,
    ...style
  };

  const contentStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    pointerEvents: "none",
    ...textStyle
  };

  return (
    <div style={bubbleStyle}>
      <img src={bubbleSvg} alt="burbuja" style={{ width: "100%", height: "100%" }} />
      <div style={contentStyle}>{text}</div>
    </div>
  );
};

TextBubble.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  rotation: PropTypes.number,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  textStyle: PropTypes.object,
  style: PropTypes.object
};

export default TextBubble;
